import React, { Component } from 'react';
import TabularReport from './TabularReport';
import DownloadableReport from './DownloadableReport';
import SkeletonContainer from '../Layout/SkeletonContainer';
import API from '../../../Configs';

class Report extends Component {
    constructor(props){
        super(props);
        this.meta = API.REPORTS;
        this.reportType = this.meta[props.reportId];
    }

    render(){
        const { reportId } = this.props;
        const { reportName } = this.reportType;
        
        return (
            <SkeletonContainer title={`Report ${ reportId } - ${ reportName }`}>
                {reportId === '9' ? <DownloadableReport reportId={reportId}/> : <TabularReport reportId={reportId}/> }
            </SkeletonContainer>
        );
    }
}

export default Report;


// WEBPACK FOOTER //
// ./src/Components/App/Reports/Report.js